import React, { useContext, useEffect, useState } from "react";
import "./Annadanam_Content_step_2.css";
import { Form, Button } from "react-bootstrap";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Successfull_Modal from "../../../common/modals/common-modal/successfull_modal/Successfull_Modal";
import { Link, useNavigate, useParams } from "react-router-dom";
import Breadcrumb_Comp from "../../../common/common_components/breadcrumb_comp/Breadcrumb_Comp";
import Common_Title_2 from "../../../common/common_components/common_title_2/Common_Title_2";
import Orange_Btn from "../../../common/common_btn/orange_btn/Orange_Btn";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { Context } from "../../../../utils/context";
import { Controller, useForm } from "react-hook-form";
import { clearDonationData, CreateUserDonationDetails } from "../../../../features/admin/user_donation_details/Slice";
import useRazorpay from "react-razorpay";
import { AllArea, AllCity, AllCountry, AllPincode, AllState } from "../../../../features/admin/common/Slice";
import { decodeId, encodeId } from "../../../../utils/common";
import { getSingleDonation } from "../../../../features/admin/donation/Slice";
import { useLocation } from "react-router-dom";

function Annadanam_Content_step_2() {

  const { id } = useParams()
  const [successModal, setSuccessModal] = useState(false);
  const [phone, setPhone] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { register, handleSubmit, watch, control, setValue, formState: { errors }, } = useForm();

  const countryOptions = [
    { value: "India", label: "India" },
    { value: "USA", label: "USA" },
    { value: "UK", label: "UK" },
  ];

  const stateOptions = [
    { value: "Maharashtra", label: "Maharashtra" },
    { value: "Gujarat", label: "Gujarat" },
  ];

  const cityOptions = [
    { value: "Mumbai", label: "Mumbai" },
    { value: "Pune", label: "Pune" },
  ];


  const step1Data = useSelector((state) => state.userDonationDetails.step1Data);

  const donation = useSelector((state) => state.donation.single_donation);




  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const amount = params.get("amount");

  useEffect(() => {
    dispatch(getSingleDonation({ id: decodeId(id) }))
  }, [dispatch])

  const CreateUserDonationDetailsfun = async (razorpay_payment_id, payload) => {
    let finalPrice = step1Data?.paymentAmount || Number(amount);
    const data = {
      razorpay_id: razorpay_payment_id,
      donation_id: step1Data?.donation_id,
      price: finalPrice,
      ...payload
    };

    const sendData = new FormData();

    sendData.append("donation_id", data?.donation_id || decodeId(id) || "");
    sendData.append("razorpay_id", data?.razorpay_id || "");
    sendData.append("price", data?.price);
    sendData.append("paymentAmount", data?.paymentAmount || "");

    sendData.append("name", data?.name || "");
    sendData.append("email", data?.email || "");
    sendData.append("contact_no", data?.contact_no || "");

    sendData.append("citizen", data?.citizen || "");
    sendData.append("tax", data?.tax || "");
    sendData.append("pan", data?.pan || "");
    sendData.append("consent", data?.consent);

    sendData.append("country_id", data?.country_id?.value || "");
    sendData.append("state_id", data?.state_id?.value || "");
    sendData.append("city_id", data?.city_id?.value || "");
    sendData.append("pincode_id", data?.pincode_id?.value || "");
    // console.log({ data });

    const res = await dispatch(CreateUserDonationDetails(sendData));
    // navigate('/home')
    if (res.meta?.requestStatus === "fulfilled") {
      setSuccessModal(true)
      setTimeout(() => {
        setSuccessModal(false);
        navigate('/home')
      }, 3000);
      dispatch(clearDonationData());
    } else if (res.meta?.requestStatus === "rejected") {

    }
  };

  const [razorid, setRazorId] = useState();
  const [Razorpay] = useRazorpay();

  const openRazorpay = (payload) => {

    let paymentAmount = payload?.paymentAmount;

    const amountInPaise = paymentAmount * 100;

    const options = {
      key: "rzp_test_I05KCFb1v5JJRc",
      amount: amountInPaise,
      currency: "INR",
      name: "OM TAPOVAN",
      description: "Test Transaction",
      image: "/assets/images/logo/logo.png",
      handler: function (response) {
        CreateUserDonationDetailsfun(response.razorpay_payment_id, payload);
        // alert("Payment successful! Payment ID: " + response.razorpay_payment_id);
      },
      prefill: {
        name: "Test User",
        email: "testuser@example.com",
        contact: "9999999999",
      },
      notes: { address: "Razorpay Corporate Office" },
      theme: { color: "#052c65" },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
  };


  const SubmitDonation = async (formData) => {

    // if (!step1Data?.paymentAmount) {
    //   navigate(`/donate`);
    //   return
    // }


    const payload = {
      ...step1Data,
      ...formData,
      paymentAmount: step1Data?.paymentAmount || Number(amount),
    };



    console.log("Final Donation Payload:", payload);
    await openRazorpay(payload)
    // dispatch(createDonation(payload));
    // open payment gateway here
  };


  const countries = useSelector((state) => state.common.all_country);
  const states = useSelector((state) => state.common.all_state);
  const cities = useSelector((state) => state.common.all_city);
  const pincodes = useSelector((state) => state.common.all_pincode);
  const areas = useSelector((state) => state.common.all_area);


  const handleCityChange = (selectedOption) => {
    console.log(selectedOption, "handleCityChange");
    setValue("city_id", selectedOption?.value);
    setValue("pincode_id", null);
    dispatch(AllPincode({ cityId: selectedOption.value }));
  };

  const handlePincodeChange = (selectedOption) => {
    console.log(selectedOption, "handlePincodeChange");
    setValue("pincode_id", selectedOption?.value);
    setValue("area_id", null);

    dispatch(AllArea({ pincodeId: selectedOption.value }));
  };

  useEffect(() => {
    dispatch(AllCountry());
  }, [dispatch]);


  const breadcrumbs = [
    { label: "EXPLORE", link: "/explore", active: false },
    {
      label: "DONATION", link: "/donate",
      active: false,
    },
    { label: donation?.name, link: "", active: false },

  ];
  return (
    <>
      <section className="Annadanam_Content_step_2">
        <div className="container">
          <section className="Volunteer_step_form">
            <Breadcrumb_Comp data={breadcrumbs} />
            <Common_Title_2 subText="Step 2 of 2: Donation" />
            <div className="userForm">
              <div className="step-Form-Container">
                <div className="form_sec">
                  <Form>
                    <Link to={`/annadanam/${encodeId(step1Data?.donation_id)}`}>
                      <button className="backbtn">BACK</button>
                    </Link>

                    <p className="text-end red_text">
                      Note: All fields are required
                    </p>

                    <div className="row">
                      {/* First Name */}
                      <div className="col-md-6 mb-3">
                        <div className="form-group">
                          <Form.Label>Full Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Full Name"
                            {...register("name", {
                              required: "Full name is required",
                              minLength: {
                                value: 3,
                                message: "Name must be at least 3 characters",
                              },
                              maxLength: {
                                value: 50,
                                message: "Name cannot exceed 50 characters",
                              },
                              pattern: {
                                value: /^[A-Za-z\s]+$/,
                                message: "Name can only contain letters and spaces",
                              },
                            })}
                          //7777777777
                          />
                        </div>
                        {errors?.name && (
                          <Form.Text className="text-danger">
                            {errors.name.message}
                          </Form.Text>
                        )}
                      </div>

                      {/* Last Name */}
                      {/* <div className="col-md-6 mb-3">
                        <div className="form-group">
                          <Form.Label>Last Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Last Name"
                            {...register("lastname", {
                              required: "Name is required",
                            })}
                          />
                        </div>
                      </div> */}

                      {/* Email */}
                      <div className="col-md-6 mb-3">
                        <div className="form-group">
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="Enter Email"
                            {...register("email", {
                              required: "Email is required",
                              pattern: {
                                value: /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
                                message: "Enter a valid email address",
                              },
                            })}
                          />
                        </div>
                        {errors?.email && (
                          <Form.Text className="text-danger">
                            {errors.email.message}
                          </Form.Text>
                        )}
                      </div>

                      {/* Phone */}
                      <div className="col-md-6 mb-3">
                        <div className="form-group">
                          <Form.Label>Phone Number</Form.Label>
                          <Form.Control
                            placeholder="Contact Number"
                            type="text"
                            name="contact_no"
                            maxLength={10} // restrict typing to 10 digits
                            {...register("contact_no", {
                              required: "Contact Number is required",
                              pattern: {
                                value: /^[0-9]+$/,  // only numbers
                                message: "Only digits are allowed",
                              },
                              minLength: {
                                value: 10,
                                message: "Contact Number must be exactly 10 digits",
                              },
                              maxLength: {
                                value: 10,
                                message: "Contact Number must be exactly 10 digits",
                              },
                            })}
                          />
                        </div>
                        {errors?.contact_no && (
                          <Form.Text className="text-danger">
                            {errors.contact_no.message}
                          </Form.Text>
                        )}
                      </div>

                      {/* Indian Citizen */}
                      <div className="col-md-6 mb-3">
                        <div className="form-group">
                          <Form.Label>Are You An Indian Citizen?</Form.Label>
                          <div>
                            <Form.Check
                              inline
                              label="Yes"
                              type="radio"
                              value="yes"
                              {...register("citizen", { required: "Please select an option" })}
                            />
                            <Form.Check
                              inline
                              label="No"
                              type="radio"
                              value="no"
                              {...register("citizen", { required: "Please select an option" })}
                            />

                            {errors?.citizen && (
                              <Form.Text className="text-danger">
                                {errors.citizen.message}
                              </Form.Text>
                            )}

                          </div>
                          <small>
                            Entering an Indian address is recommended
                          </small>
                        </div>
                      </div>

                      {/* Tax Benefit */}
                      <div className="col-md-6 mb-3">
                        <div className="form-group">
                          <Form.Label>Do You Want 80G Tax Benefits?</Form.Label>
                          <div>
                            <Form.Check
                              inline
                              label="Yes"
                              type="radio"
                              value="yes"
                              {...register("tax", { required: "Please select an option" })}
                            />
                            <Form.Check
                              inline
                              label="No"
                              type="radio"
                              value="no"
                              {...register("tax", { required: "Please select an option" })}
                            />
                            {errors?.tax && (
                              <Form.Text className="text-danger">
                                {errors.tax.message}
                              </Form.Text>
                            )}
                          </div>

                          <small>
                            To avail tax benefits under 80G, you need to provide
                            PAN / AADHAR.
                          </small>
                        </div>
                      </div>

                      {/* PAN Number */}
                      <div className="col-md-6 mb-3">
                        <div className="form-group">
                          <Form.Label>PAN Number</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter PAN Number"
                            {...register("pan", {
                              validate: (value, formValues) => {
                                // If tax benefit selected, PAN is mandatory
                                if (formValues.tax === "yes" && !value) {
                                  return "PAN is required for 80G benefits";
                                }

                                // If PAN is entered, validate format
                                if (value && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value)) {
                                  return "Invalid PAN format (ABCDE1234F)";
                                }

                                return true;
                              },
                            })}
                          />

                        </div>
                        {errors?.pan && (
                          <Form.Text className="text-danger">
                            {errors.pan.message}
                          </Form.Text>
                        )}

                      </div>


                      {/* Country */}
                      <div className="col-md-6 mb-3">
                        <div className="form-group">
                          <Form.Label>Country</Form.Label>
                          <Controller
                            className="Select_Dropdown_holder"

                            name="country_id"
                            control={control}
                            rules={{ required: "Country is required" }}
                            render={({ field }) => (
                              <Select
                                placeholder="Select Country"
                                options={countries}
                                className="mb-3"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    borderColor: errors.country_id ? "red" : base,
                                  }),
                                }}
                                {...field}
                                onChange={(selectedOption) => {
                                  field.onChange(selectedOption);
                                  setValue("state_id", null);
                                  setValue("city_id", null);
                                  setValue("pincode_id", null);
                                  dispatch(AllState({ countryId: selectedOption.value }));
                                }}
                              />
                            )}
                          />
                        </div>
                        {errors?.country_id && (
                          <Form.Text className="text-danger">
                            {errors.country_id.message}
                          </Form.Text>
                        )}
                      </div>

                      {/* State */}
                      <div className="col-md-6 mb-3">
                        <div className="form-group">
                          <Form.Label>State</Form.Label>
                          <Controller
                            className="Select_Dropdown_holder"
                            name="state_id"
                            control={control}
                            rules={{ required: "State is required" }}
                            render={({ field }) => (
                              <Select
                                placeholder="Select State"
                                options={states}
                                className="mb-3"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    borderColor: errors.state_id ? "red" : base,
                                  }),
                                }}
                                {...field}
                                onChange={(selectedOption) => {
                                  field.onChange(selectedOption);
                                  setValue("city_id", null);
                                  setValue("pincode_id", null);
                                  dispatch(AllCity({ stateId: selectedOption.value }));
                                }}
                              />
                            )}
                          />
                        </div>
                        {errors?.state_id && (
                          <Form.Text className="text-danger">
                            {errors.state_id.message}
                          </Form.Text>
                        )}
                      </div>

                      {/* City */}
                      <div className="col-md-6 mb-3">
                        <div className="form-group">
                          <Form.Label>City</Form.Label>
                          <Controller
                            className="Select_Dropdown_holder"
                            name="city_id" // Form field name
                            control={control}
                            rules={{ required: "City is required" }}
                            render={({ field }) => (
                              <Select
                                noOptionsMessage={() => "City in this State"}
                                className="mb-3"
                                placeholder="Select City"
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors.city_id ? "red" : baseStyles,
                                  }),
                                }}
                                {...field}
                                options={cities}
                                onChange={(selectedOption) => {
                                  field.onChange(selectedOption); // Update Controller's value
                                  handleCityChange(selectedOption);
                                  setValue("city_id", selectedOption);
                                }}
                              />
                            )}
                          />
                        </div>
                        {errors?.city_id && (
                          <Form.Text className="text-danger">
                            {errors.city_id.message}
                          </Form.Text>
                        )}
                      </div>

                      {/* Pin Code */}
                      <div className="col-md-6 mb-3">
                        <div className="form-group">
                          <Form.Label>Pin/ Zip Code</Form.Label>
                          <Controller
                            className="Select_Dropdown_holder"
                            name="pincode_id" // Form field name
                            control={control}
                            rules={{ required: "Pincode is required" }}
                            render={({ field }) => (
                              <Select
                                noOptionsMessage={() => "Pincode not available"}
                                className="mb-3"
                                placeholder="Select Pincode"
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors.pincode_id
                                      ? "red"
                                      : baseStyles,
                                  }),
                                }}
                                {...field}
                                options={pincodes}
                                onChange={(selectedOption) => {
                                  field.onChange(selectedOption); // Update Controller's value
                                  handlePincodeChange(selectedOption);
                                  setValue("pincode_id", selectedOption);
                                }}
                              />
                            )}
                          />
                        </div>
                        {errors?.pincode_id && (
                          <Form.Text className="text-danger">
                            {errors.pincode_id.message}
                          </Form.Text>
                        )}
                      </div>


                      {/* Checkbox */}
                      <div className="col-md-12 mb-3">
                        <div className="form-group">
                          <Form.Check
                            inline
                            type="checkbox"
                            label="By using this form you agree with the storage and handling of your data by this website."
                            {...register("consent", {
                              required: "You must accept the terms",
                            })}
                          />

                          {errors?.consent && (
                            <Form.Text className="text-danger">
                              {errors.consent.message}
                            </Form.Text>
                          )}

                        </div>
                      </div>

                      {/* Contribution Text */}
                      <div className="note_holder">
                        <p className="red_text mb-0">
                          Your Contribution of ₹ {step1Data?.paymentAmount || amount || "0"} is Greatly appreciated
                        </p>

                        {/* Pay Button */}

                        <div className="btn_holder">
                          <Orange_Btn
                            btnText={
                              <>
                                <FontAwesomeIcon icon={faLock} className="me-3" /> Pay Securely
                              </>
                            }
                            onClick={handleSubmit(SubmitDonation)}
                          />
                        </div>
                      </div>
                    </div>
                  </Form>

                  <Successfull_Modal
                    show={successModal}
                    onHide={() => setSuccessModal(false)}
                    headtext={"Payment Confirmation"}
                    successfultext={"Payment Submitted Successfully!"}
                    subtext={"Thank you for your contribution."}
                    subtext2={"Have a nice time ahead!"}
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </>
  );
}

export default Annadanam_Content_step_2;
